import { createFileRoute, redirect } from '@tanstack/react-router';
import { ProjectEnrichmentSettings } from '@/components/enrichment/project-enrichment-settings';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute(
  '/_auth/_side-layout/automations_/enrichment',
)({
  component: AutomationsEnrichmentPage,
  beforeLoad: async ({ context }) => {
    if (!hasPermission(context.userRole, { action: ['create'] })) {
      throw redirect({ to: '/' });
    }
  },
});

function AutomationsEnrichmentPage() {
  return <ProjectEnrichmentSettings />;
}
